import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux'

import { registerLocale, setDefaultLocale } from  "react-datepicker";
import { de } from 'date-fns/locale/de';

// Semantic UI
import { Form, FormGroup, FormInput, FormSelect, Button, Icon, Table, Modal, FormCheckbox } from 'semantic-ui-react';

// System data
import { optionsKontingent } from './systemdata';
import { optionsRoom } from "./systemdata";
import { optionsLockedOccupancies } from "./systemdata";
import { optionsInfants } from "./systemdata";

// Actions
import { doContractAction } from "./contractSlice";
import { setContractData } from "./contractSlice";

// Styles
import "react-datepicker/dist/react-datepicker.css";
import './contract.css';

//
registerLocale('de', de);
setDefaultLocale('de');



/**
 * 
 * @param {bool} editMode 
 * @returns 
 */
const Max2ContractSeasonRoomsRooms = ({ editMode }) => {
  // local State
  const [openNew, setOpenNew] = useState(false);
  const [newRoomCode, setNewRoomCode] = useState(null);
  const [newAllotmentStrg, setNewAllotmentStrg] = useState('X');
  const [newAllotmentRoom, setNewAllotmentRoom] = useState(null);
  const [newAllotmentMax, setNewAllotmenMax]    = useState('');
  
  // global State
  const dispatch = useDispatch();
  const Contract = useSelector((state) => state.contract.data.Contract);
  const NewRoom = {...useSelector((state) => state.contract.NewRoom)};
    

  // Edit mode?
  const readOnly = editMode ? false : true;

  // check if rooms defined
  if (typeof Contract?.Rooms === 'undefined' || !Contract?.Rooms.length) {
    return (
      <>
      <Button basic circular icon labelPosition='left' onClick={() => setOpenNew(true)}>
        <Icon name='add' />
        Zimmer hinzufügen
      </Button>
      </>
    )
  }

  
  // build options for referenc room select
  const optionsXRooms = Contract?.Rooms.map(room => {
    return { value: room.RoomCode, key: room.RoomCode, text: room.RoomCode + ' - ' + room.RoomName }
  });

  // only numbers allowed in allotment max input
  const handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  //
  const handleAddNewRoom = () => {
    
    // get room name
    let room_name = '';
    optionsRoom.forEach(option => {
      if (option.value === newAllotmentRoom)  {
        room_name = option.text;
      }
    });
    
    // fill new room object 
    NewRoom.RoomCode = newRoomCode;
    NewRoom.RoomName = room_name;
    NewRoom.Allotment = { Type: newAllotmentStrg, ReferenceCode: newAllotmentRoom, Limit: newAllotmentMax };

    // reset values
    setNewRoomCode(null);
    setNewAllotmentStrg('X');
    setNewAllotmentRoom(null);
    setNewAllotmenMax('');

    //
    dispatch(doContractAction({target: 'Room.addRoom', value: NewRoom}))
    setOpenNew(false);
  }


  if (readOnly) {
    return (
      <Table celled structured striped basic='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2">Zimmertyp</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Abkürzung</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Kontingent-Typ</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">VZ</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">PAX</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">ADL</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">CHD</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Gesperrte Belegungen</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Adult only?</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Infants</Table.HeaderCell>
            {!readOnly && (
              <Table.HeaderCell rowSpan="2"></Table.HeaderCell>
            )}
          </Table.Row>
          <Table.Row>
          <Table.HeaderCell>min</Table.HeaderCell>
          <Table.HeaderCell>max</Table.HeaderCell>
          <Table.HeaderCell>min</Table.HeaderCell>
          <Table.HeaderCell>max</Table.HeaderCell>
          <Table.HeaderCell>min</Table.HeaderCell>
          <Table.HeaderCell>max</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Contract.Rooms.map((room, roomKey)=>(
            <Table.Row key={room.RoomCode}>
              <Table.Cell>{room.RoomName}</Table.Cell>
              <Table.Cell>{room.RoomCode}</Table.Cell>
              <Table.Cell>{room.Allotment.Type === 'BASIC' ? 'Grundzimmer' : room.Allotment.Type === 'PARTIAL' ? 'Teilkontingent von '+room.Allotment.ReferenceCode : 'Maximal-Teilkontingent ('+room.Allotment.Limit+') von '+room.Allotment.ReferenceCode}</Table.Cell>
              <Table.Cell>{room.Occupancy.FullPaying}</Table.Cell>
              <Table.Cell>{room.Occupancy.PaxMin}</Table.Cell>
              <Table.Cell>{room.Occupancy.PaxMax}</Table.Cell>
              <Table.Cell>{room.Occupancy.AdultMin}</Table.Cell>
              <Table.Cell>{room.Occupancy.AdultMax}</Table.Cell>
              <Table.Cell>{room.Occupancy.ChildrenMin}</Table.Cell>
              <Table.Cell>{room.Occupancy.ChildrenMax}</Table.Cell>
              <Table.Cell>{room.LockedOccupancies.join(', ')}</Table.Cell>
              <Table.Cell>
                <Form>
                  <FormGroup>
                    {room.AdultOnly.IsAdultOnly && (<Icon circular name='check' />)}
                    {room.AdultOnly.IsAdultOnly && (<> ab {room.AdultOnly.AdultAge} Jahre</>)}                    
                  </FormGroup>
                </Form>
              </Table.Cell>
              <Table.Cell>
                {optionsInfants.map(option => {
                  if (option.value === room.Infants) {
                    return <span key={option.value}>{option.text}</span>
                  }
                  return null;
                })}
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    );
  }




  return (
    <>
      <Table celled structured striped basic='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2">Zimmertyp</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Abkürzung</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Kontingent-Typ</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">VZ</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">PAX</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">ADL</Table.HeaderCell>
            <Table.HeaderCell colSpan="2">CHD</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Gesperrte Belegungen</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Adult only?</Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">Infants</Table.HeaderCell>
            {!readOnly && (
              <Table.HeaderCell rowSpan="2"></Table.HeaderCell>
            )}
          </Table.Row>
          <Table.Row>
          <Table.HeaderCell>min</Table.HeaderCell>
          <Table.HeaderCell>max</Table.HeaderCell>
          <Table.HeaderCell>min</Table.HeaderCell>
          <Table.HeaderCell>max</Table.HeaderCell>
          <Table.HeaderCell>min</Table.HeaderCell>
          <Table.HeaderCell>max</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {Contract.Rooms.map((room, roomKey)=>(
            <Table.Row key={room.RoomCode}>
              <Table.Cell>{room.RoomName}</Table.Cell>
              <Table.Cell>{room.RoomCode}</Table.Cell>
              <Table.Cell>{room.Allotment.Type === 'BASIC' ? 'Grundzimmer' : room.Allotment.Type === 'PARTIAL' ? 'Teilkontingent von '+room.Allotment.ReferenceCode : 'Maximal-Teilkontingent ('+room.Allotment.Limit+') von '+room.Allotment.ReferenceCode}</Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.FullPaying}  onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.FullPaying', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.PaxMin}      onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.PaxMin', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.PaxMax}      onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.PaxMax', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.AdultMin}    onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.AdultMin', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.AdultMax}    onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.AdultMax', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.ChildrenMin} onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.ChildrenMin', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormInput readOnly={readOnly} type="number" className="small" maxLength={1} style={{width: "40px"}} value={room.Occupancy.ChildrenMax} onKeyPress={handleKeyPress} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Occupancy.ChildrenMax', value: parseInt(data.value)}))} /></Table.Cell>
              <Table.Cell><FormSelect readOnly={readOnly} multiple className="uiselect_small" options={optionsLockedOccupancies} value={room.LockedOccupancies} placeholder="bitte wählen" onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.LockedOccupancies', value: data.value}))} /></Table.Cell>
              <Table.Cell>
                <Form>
                  <FormGroup>
                    <FormCheckbox toggle checked={room.AdultOnly.IsAdultOnly ? true : false} onClick={() => { if (!readOnly) { dispatch(setContractData({roomKey: roomKey, target: 'Rooms.AdultOnly.IsAdultOnly', value: !room.AdultOnly.IsAdultOnly}))}}} />
                    {room.AdultOnly.IsAdultOnly && (
                      <FormInput readOnly={readOnly} type="number" className="small" maxLength={2} onKeyPress={handleKeyPress} style={{width: "50px"}} value={room.AdultOnly.AdultAge} onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.AdultOnly.AdultAge', value: parseInt(data.value)}))} />
                    )}                    
                  </FormGroup>
                </Form>
              </Table.Cell>
              <Table.Cell><FormSelect search readOnly={readOnly} className="uiselect_small" options={optionsInfants} value={room.Infants} placeholder="bitte wählen" onChange={(e, data) => dispatch(setContractData({roomKey: roomKey, target: 'Rooms.Infants', value: data.value}))} /></Table.Cell>
              {!readOnly && (
                <Table.Cell>
                    <Button basic circular icon>
                      <Icon name='trash' onClick={() => dispatch(doContractAction({target: 'Room.delRoom', value: roomKey}))} />
                    </Button>
                </Table.Cell>
              )}
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
      {!readOnly && (
        <Button basic circular icon labelPosition='left' onClick={() => setOpenNew(true)}>
            <Icon name='add' />
            Zimmer hinzufügen
        </Button>
      )}
  
      <Modal size="tiny" open={openNew} onClose={() => setOpenNew(false)}>
        <Modal.Header>Zimmer hinzufügen</Modal.Header>
        <Modal.Content>
          <Form>
            <FormSelect search selection label="Zimmerart" options={optionsRoom} value={newRoomCode} placeholder='bitte wählen' onChange={(e, data) => setNewRoomCode(data.value)} />
            <FormSelect search selection label="Kontingentsteuerung" options={optionsKontingent} value={newAllotmentStrg} placeholder='Kontingentsteuerung' onChange={(e, data) => setNewAllotmentStrg(data.value)} />
            {(newAllotmentStrg === 'T' || newAllotmentStrg === 'K') && (
              <FormGroup>
                <FormSelect search selection label="zugehöriges Grundzimmer" options={optionsXRooms} value={newAllotmentRoom} placeholder='Grundzimmer' onChange={(e, data) => setNewAllotmentRoom(data.value)} />
                {newAllotmentStrg === 'K' && (
                  <FormInput type="number" label="max. Kontingent" maxLength={3} value={newAllotmentMax} placeholder='max. Kontingent' onKeyPress={handleKeyPress} onChange={(e, data) => setNewAllotmenMax(parseInt(data.value))} />
                )}
              </FormGroup>
            )}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button basic circular icon labelPosition='left' onClick={() => setOpenNew(false)}>
            <Icon name='times' />
            Abbrechen
          </Button>
          <Button primary circular icon labelPosition='left' onClick={() => handleAddNewRoom()}>
            <Icon name='plus' />
            hinzufügen
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default Max2ContractSeasonRoomsRooms;